// From MaxMind
/* global geoip2 */

// globals created in geocode.js
window.geoLocation = null;

(function () {
    const locationCookieName = 'geoLocation';
    const cookieLifetime = 7;

    /**
     * return parsed cookie or null if failure
     */
    function loadLocationFromCookie() {
        const locationCookie = readCookie(locationCookieName);
        if (locationCookie) {
            return JSON.parse(locationCookie);
        } else {
            return null;
        }
    }
    const cookieGeoLocation = loadLocationFromCookie();

    const runMaxmind = function () {
        const maxmindTimeout = setTimeout(function () {
            document.dispatchEvent(new CustomEvent('maxmindFailure'));
        }, 3000);
        const po = document.createElement('script'); po.type = 'text/javascript'; po.async = true;

        po.onload = function () {
            document.dispatchEvent(new CustomEvent('maxmindLoaded'));
            clearInterval(maxmindTimeout);
        };

        // This is prefetched in general.tag, so we should just have to parse it now
        po.src = '//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js';
        const scripts = document.getElementsByTagName('script');
        const s = scripts[0]; s.parentNode.appendChild(po);
    };

    function trackEvent(eventName) {
        dcAnalytics.trackEventGA([pageName, 'geo lookup', eventName]);
    }

    function exportGeoLocation(newGeoLocation) {
        window.geoLocation = newGeoLocation;

        $(document).trigger('geoCallComplete', newGeoLocation);
    }

    /**
     * Called when Maxmind's script loads. Defines refreshGeoLocation
     * method which uses Maxmind (geoip2). Fires geocodeLoaded event.
     */
    function exportGeocodeMethods() {
        const geocodeModule = (function () {
            const module = {};
            // allows us to stub this out in test

            function checkGeoServer() {
                geoip2.city(onSuccess, onError);
            }

            function onError(error) {
                // avoid ReferenceError, and track, but otherwise do nothing
                $(document).trigger('geoLibraryError', error);
                exportGeoLocation(null);

                trackEvent('Maxmind error');
            }

            function onSuccess(location) {
                const newGeoLocation = extractLocation(location);

                if (canGetState(location)) {
                    trackEvent('successful lookup');
                    $(document).trigger('detailedLocation', newGeoLocation);
                } else {
                    trackEvent('unable to use location');
                    $(document).trigger('unusableLocation', newGeoLocation);
                }

                exportGeoLocation(newGeoLocation);

                window.createCookie(locationCookieName, JSON.stringify(window.geoLocation), cookieLifetime);
            }

            /**
             * Extracts fields from the maxmind location object to a simpler VO with
             * all the fields we need.
             */
            function extractLocation(location) {
                console.log(JSON.stringify(location));
                if (!canGetState(location)) {
                    return {
                        country: getCountry(location),
                        stateCode: 'US',
                        zoneId: 0,
                    };
                }

                return {
                    country: getCountry(location),
                    stateCode: getState(location),
                    zoneId: parseInt(getGeoZone(location)),
                    zip: location.postal && location.postal.code,
                    latitude: location.location.latitude,
                    longitude: location.location.longitude,
                    cityName: location.city && location.city.names.en,
                };
            }
            function getState(location) {
                return location.subdivisions[0].iso_code;
            }
            function getCountry(location) {
                return location.country.iso_code;
            }

            /**
             * @return boolean True if the location has a country code US and the location also has state
             * data stored.
             */
            function canGetState(location) {
                return location &&
                    location.country &&
                    location.subdivisions &&
                    location.country.iso_code === 'US' &&
                    location.subdivisions.length > 0 &&
                    location.subdivisions[0].iso_code !== undefined;
            }

            /**
             * Look up Zone based on state using stateLatLong array
             * @return Number int zone id for the state in this location
             */
            function getZoneBasedOnState(location) {
                const state = getState(location);
                const zoneAndLatLongOfState = window.stateLatLong[state];

                if (zoneAndLatLongOfState === undefined) {
                    return null;
                } else {
                    const zoneId = zoneAndLatLongOfState[0].replace('zone', '');
                    return parseInt(zoneId);
                }
            }

            /**
             * @return Number the int zone id for this location
             */
            function getGeoZone(location) {
                const defaultGeoZone = getZoneBasedOnState(location);

                if (isNonStateZone(location)) {
                    return getNonStateZone(location);
                } else {
                    return defaultGeoZone;
                }
            }

            function getCity(location) {
                return location.location.metro_code;
            }

            // Taken from geo.conf.
            // Keys are GeoIP metrocodes for these locations. Values are corresponding
            // zone IDs in our system.
            const nonStateZoneMappings = {
                501: 103, // New York (City)

                // New York (State)
                502: 104, // Binghamton
                514: 104, // Buffalo
                526: 104, // Utica-Rome
                532: 104, // Albany-Schenectady-Troy
                538: 104, // Rochester
                549: 104, // Watertown
                555: 104, // Syracuse
                565: 104, // Elmira

                // California (Northern)
                800: 402, // Bakersfield
                802: 402, // Eureka
                807: 402, // San Francisco
                828: 402, // Monterey-Salinas
                862: 402, // Sacramento
                866: 402, // Fresno
                868: 402, // Chico-Redding

                // California (Southern)
                803: 411, // Los Angeles
                804: 411, // Palm Springs
                825: 411, // San Diego
                855: 411, // Santa Barbara

                // Illinois (Chicago)
                602: 201,

                // Illinois (State)
                610: 202, // Rockford
                648: 202, // Champaign-Springfield-Decatur
                675: 202, // Peoria-Bloomington
                682: 202, // Davenport-Rock Island-Moline
                717: 202, // Quincy
            };

            function isNonStateZone(location) {
                return nonStateZoneMappings[getCity(location)] != null;
            }

            function getNonStateZone(location) {
                const metroCode = getCity(location);

                return nonStateZoneMappings[metroCode];
            }

            module.checkGeoServer = checkGeoServer;
            return module;
        })();

        function standardRefreshGeoLocation() {
            if (cookieGeoLocation) {
                trackEvent('cookie read');
                $(document).trigger('detailedLocation', cookieGeoLocation);
                exportGeoLocation(cookieGeoLocation);
            } else {
                geocodeModule.checkGeoServer();
            }
        }

        window.refreshGeoLocation = standardRefreshGeoLocation;
        $(document).trigger('geocodeLoaded');
    }

    /**
     * Called when a timeout makes us give up on waiting for Maxmind to load,
     * or when we determine we can directly use the cookie and skip Maxmind.
     * Defines refreshGeoLocation functions that do not use Maxmind's geoip2 service.
     * Fires geocodeLoaded event.
     */
    function exportFallbackGeocodeMethods() {
        function fallbackRefreshGeoLocation() {
            if (cookieGeoLocation) {
                trackEvent('Maxmind skipped - cookie read');
                $(document).trigger('detailedLocation', cookieGeoLocation);
                exportGeoLocation(cookieGeoLocation);
            } else {
                trackEvent('Maxmind timeout - no cookie found');
                $(document).trigger('geoLibraryNotLoaded');
                exportGeoLocation(null);
            }
        }

        window.refreshGeoLocation = fallbackRefreshGeoLocation;
        $(document).trigger('geocodeLoaded');
    }

    function isNotTestEnvironment() {
        // eslint-disable-next-line no-undef
        return (typeof isTestEnv === 'undefined' || !isTestEnv);
    }

    // export geocode methods if/when geoip2 is available
    if (isNotTestEnvironment()) {
        if (cookieGeoLocation) {
            // If geo location is cached, simply use that value and skip loading maxmind
            exportFallbackGeocodeMethods();
        } else {
            // Standard behavior
            $(document).bind('maxmindLoaded', function () {
                exportGeocodeMethods();
            });

            // Behavior when Maxmind's JS doesn't load
            $(document).bind('maxmindFailure', function () {
                $(document).unbind('maxmindLoaded');
                exportFallbackGeocodeMethods();
            });

            // We delay loading the maxmind script till we know we need it to avoid the overhead of parsing it unnecessarily
            runMaxmind();
        }
    }

    // Are these actually used outside this file? Maybe they were just for testing
    window.exportGeocodeMethods = exportGeocodeMethods;
    window.exportFallbackGeocodeMethods = exportFallbackGeocodeMethods;
})();
